import {
  DeleteOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Row,
  Select,
} from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { setting_all } from "../../../services/setting";

type Props = {
  form: any;
};

const ResourcePage = (props: Props) => {
  const { t } = useTranslation();

  const [resources, setResources] = useState<any[]>([]);

  const timePattern = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;

  const handleTimeChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    setValue: (value: string) => void,
  ) => {
    let value = e.target.value;
    value = value.replace(/[^0-9:]/g, "");
    const segments = value.split(":");
    if (segments.length > 3) return;
    if (/^([01]?\d|2[0-3])?(:([0-5]?\d)?)?(:([0-5]?\d)?)?$/.test(value)) {
      setValue(value);
    }
  };

  const DeleteButtonWithConfirmSub = ({ onDelete = () => {} }) => (
    <Popconfirm
      title={t("Alert delete title")}
      description={t("Alert delete detail")}
      onConfirm={onDelete}
      okText={t("yes")}
      cancelText={t("no")}
    >
      <DeleteOutlined
        style={{
          color: "red",
          cursor: "pointer",
          fontSize: "16px", // ปรับขนาดไอคอน
        }}
      />
    </Popconfirm>
  );

  // const handleHostnameChange = (
  //   selectedHostname: any,
  //   type: "task" | "evaluation",
  // ) => {
  //   console.log("selectedHostname:", selectedHostname);
  //   console.log("resources:", resources);
  //   const selectedResource = resources.find(
  //     (resource) => resource.id === selectedHostname,
  //   );

  //   if (!selectedResource) return; // ✅ ถ้าไม่เจอ hostname ไม่ต้องทำอะไร

  //   if (params.action !== "edit") {
  //     if (type === "task") {
  //       props.form.resetFields(["cpu", "gpu", "ram"]);
  //     } else {
  //       props.form.resetFields(["cpueva", "gpueva", "rameva"]);
  //     }
  //   }

  //   const cpuData =
  //     selectedResource.detail.cpu.map((item: any) => {
  //       return { cpu: item.name || "", core: item.core };
  //     }) || null;
  //   const cpuEvalData =
  //     selectedResource.detail.cpu.map((item: any) => {
  //       return { cpueva: item.name || "", coreeva: item.core };
  //     }) || null;

  //   const gpuData =
  //     selectedResource.detail.gpu.map((item: any) => {
  //       return { gpu: item.name || "", card: item.card };
  //     }) || null;
  //   const gpuEvalData =
  //     selectedResource.detail.gpu.map((item: any) => {
  //       return { gpueva: item.name || "", cardeva: item.card };
  //     }) || null;

  //   const ramData = selectedResource.detail.ram || null;
  //   console.log("cpuData", cpuData);
  //   if (type === "task") {
  //     setAvailableCpus(selectedResource.detail.cpu || []);
  //     setAvailableGpus(selectedResource.detail.gpu || []);
  //     props.form.setFieldsValue({
  //       hostname: selectedResource.hostname,
  //       cpu: cpuData,
  //       gpu: gpuData,
  //       ram: ramData,
  //       ip: selectedResource.ip,
  //       imgdockertimeout: 2,
  //     });
  //   } else {
  //     setAvailableCpuseva(selectedResource.detail.cpu || []);
  //     setAvailableGpuseva(selectedResource.detail.gpu || []);

  //     props.form.setFieldsValue({
  //       hostnameevaluation: selectedResource.hostname,
  //       cpueva: cpuEvalData,
  //       gpueva: gpuEvalData,
  //       // cpueva: cpuData ? [{ cpueva: cpuData[0].cpu, coreeva: 1 }] : null,
  //       // gpueva: gpuData ? [{ gpueva: gpuData[0].gpu, cardeva: 1 }] : null,
  //       rameva: ramData,
  //       ip_eval: selectedResource.ip,
  //       imgdockertimeouteva: 2,
  //     });
  //   }
  // };

  const handleResourceChange = (selectedId: any, index: any, listName: any) => {
    const selectedResource = resources.find((r) => r.id === selectedId);
    if (!selectedResource) return;

    const isEval = listName === "evaluations";
    const currentList = props.form.getFieldValue(listName) || [];

    // เตรียมข้อมูล CPU/GPU ตาม Key ของแต่ละฝั่ง
    const cpuData = selectedResource.detail.cpu.map((item: any) => ({
      [isEval ? "cpueva" : "cpu"]: item.name || "",
      [isEval ? "coreeva" : "core"]: item.core,
    }));

    const gpuData = selectedResource.detail.gpu.map((item: any) => ({
      [isEval ? "gpueva" : "gpu"]: item.name || "",
      [isEval ? "cardeva" : "card"]: item.card,
    }));

    // อัปเดตข้อมูลในแถวที่เลือก
    currentList[index] = {
      ...currentList[index],
      preset: selectedId,
      [isEval ? "hostnameevaluation" : "hostname"]: selectedResource.hostname,
      [isEval ? "ip_eval" : "ip"]: selectedResource.ip,
      [isEval ? "cpueva" : "cpu"]: cpuData,
      [isEval ? "gpueva" : "gpu"]: gpuData,
      [isEval ? "rameva" : "ram"]: selectedResource.detail.ram,
      [isEval ? "imgdockertimeouteva" : "imgdockertimeout"]: 2,
    };

    props.form.setFieldsValue({ [listName]: [...currentList] });
  };

  const getSetting = async () => {
    try {
      const res = await setting_all();
      if (res.data[0]) {
        const resources = JSON.parse(res.data[0].setting);
        if (Array.isArray(resources)) {
          setResources(resources);
        } else {
          console.warn("Resources array is invalid or empty.");
        }
      } else {
        console.warn("No data received from API.");
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  useEffect(() => {
    getSetting();
  }, []);

  return (
    <div className="add-task-body-layout">
      {/* Resouce for task */}
      {props.form.getFieldValue("submissiontype") == 1 && (
        <Row gutter={24}>
          <Card
            title={
              <Row justify={"space-between"}>
                <Col style={{ fontSize: "16px" }}>{t("Resource for task")}</Col>
              </Row>
            }
            style={{
              width: "100%",
              backgroundColor: "#F3F3F1",
              borderColor: "#cccccc",
            }}
          >
            <Form.List name="tasks" initialValue={[{}]}>
              {(fields, { add, remove }) => (
                <>
                  {fields.map((field, index) => (
                    <Card
                      key={field.key}
                      size="small"
                      title={`Task Machine #${index + 1}`}
                      style={{
                        marginBottom: 16,
                        borderLeft: "4px solid #1890ff",
                        backgroundColor: "#F3F3F1",
                        borderTop: "1px solid #cccccc",
                        borderRight: "1px solid #cccccc",
                        borderBottom: "1px solid #cccccc",
                      }}
                      // extra={
                      //   // fields.length > 1 && (
                      //   <MinusCircleOutlined
                      //     onClick={() => remove(field.name)}
                      //     style={{ color: "#ff4d4f", fontSize: "16px" }}
                      //   />
                      //   // )
                      // }
                      extra={
                        <DeleteButtonWithConfirmSub
                          onDelete={() => remove(field.name)}
                        />
                      }
                    >
                      {/* Select Preset with Unique Logic */}
                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const selectedIds = (getFieldValue("tasks") || [])
                            .map((m: any) => m?.preset)
                            .filter(Boolean);
                          return (
                            <Form.Item
                              {...field}
                              name={[field.name, "preset"]}
                              label={t("Machine Preset")}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select a preset",
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select Preset"
                                onChange={(val) =>
                                  handleResourceChange(val, field.name, "tasks")
                                }
                                options={resources.map((r) => ({
                                  label: r.preset,
                                  value: r.id,
                                  disabled:
                                    selectedIds.includes(r.id) &&
                                    getFieldValue([
                                      "tasks",
                                      field.name,
                                      "preset",
                                    ]) !== r.id,
                                }))}
                              />
                            </Form.Item>
                          );
                        }}
                      </Form.Item>

                      {/* Details Section (Show only when preset is selected) */}
                      <Form.Item
                        shouldUpdate={(prev, curr) => prev.tasks !== curr.tasks}
                        noStyle
                      >
                        {({ getFieldValue }) => {
                          const hasPreset = getFieldValue([
                            "tasks",
                            field.name,
                            "preset",
                          ]);
                          if (!hasPreset) return null;

                          return (
                            <div style={{ marginTop: 16 }}>
                              <Row gutter={16}>
                                <Col span={12}>
                                  <Form.Item
                                    {...field}
                                    name={[field.name, "hostname"]}
                                    label="Hostname"
                                  >
                                    <Input disabled />
                                  </Form.Item>
                                </Col>
                                <Col span={12}>
                                  <Form.Item
                                    {...field}
                                    name={[field.name, "ip"]}
                                    label="IP"
                                  >
                                    <Input disabled />
                                  </Form.Item>
                                </Col>
                              </Row>

                              {/* Nested CPU/GPU Lists */}
                              <Form.List name={[field.name, "cpu"]}>
                                {(subFields) =>
                                  subFields.map((subField, i) => (
                                    <Row key={subField.key} gutter={8}>
                                      <Col span={16}>
                                        <Form.Item
                                          {...subField}
                                          name={[subField.name, "cpu"]}
                                          label={`CPU ${i + 1}`}
                                        >
                                          <Input disabled />
                                        </Form.Item>
                                      </Col>
                                      <Col span={8}>
                                        <Form.Item
                                          {...subField}
                                          name={[subField.name, "core"]} // หรือ "coreeva"
                                          label="Core"
                                          rules={[
                                            {
                                              required: true,
                                              message: "กรุณาระบุ core",
                                            },
                                            ({ getFieldValue }) => ({
                                              validator(_, value) {
                                                // 1. ดึง ID ของ Preset ในแถวปัจจุบันออกมา
                                                const presetId = getFieldValue([
                                                  "tasks",
                                                  field.name,
                                                  "preset",
                                                ]);
                                                const selectedResource =
                                                  resources.find(
                                                    (r) => r.id === presetId,
                                                  );

                                                if (selectedResource) {
                                                  // 2. หาค่า Core สูงสุดจาก Preset (อ้างอิงตาม index ของ CPU)
                                                  const maxCore =
                                                    selectedResource.detail.cpu[
                                                      subField.name
                                                    ]?.core;
                                                  if (value > maxCore) {
                                                    return Promise.reject(
                                                      new Error(
                                                        `จำนวน Core ไม่ควรเกิน ${maxCore} (จำนวนที่รองรับ)`,
                                                      ),
                                                    );
                                                  }
                                                }
                                                return Promise.resolve();
                                              },
                                            }),
                                          ]}
                                        >
                                          <InputNumber
                                            min={1}
                                            style={{ width: "100%" }}
                                            type="number"
                                          />
                                        </Form.Item>
                                      </Col>
                                    </Row>
                                  ))
                                }
                              </Form.List>
                              <Form.List name={[field.name, "gpu"]}>
                                {(subFields) =>
                                  subFields.map((subField, i) => (
                                    <Row key={subField.key} gutter={8}>
                                      <Col span={16}>
                                        <Form.Item
                                          {...subField}
                                          name={[subField.name, "gpu"]}
                                          label={`GPU ${i + 1}`}
                                        >
                                          <Input disabled />
                                        </Form.Item>
                                      </Col>
                                      <Col span={8}>
                                        <Form.Item
                                          {...subField}
                                          name={[subField.name, "card"]}
                                          label="Card ID"
                                        >
                                          <InputNumber
                                            disabled={true}
                                            style={{ width: "100%" }}
                                            type="number"
                                          />
                                        </Form.Item>
                                      </Col>
                                    </Row>
                                  ))
                                }
                              </Form.List>

                              <Row gutter={16}>
                                <Col span={12}>
                                  <Form.Item
                                    {...field}
                                    name={[field.name, "ram"]} // หรือ "rameva"
                                    label="RAM (GB)"
                                    rules={[
                                      ({ getFieldValue }) => ({
                                        validator(_, value) {
                                          const presetId = getFieldValue([
                                            "tasks",
                                            field.name,
                                            "preset",
                                          ]); // หรือ 'evaluations'
                                          const selectedResource =
                                            resources.find(
                                              (r) => r.id === presetId,
                                            );

                                          if (
                                            selectedResource &&
                                            value > selectedResource.detail.ram
                                          ) {
                                            return Promise.reject(
                                              new Error(
                                                `จำนวน Ram ไม่ควรเกิน ${selectedResource.detail.ram} (จำนวนที่รองรับ)`,
                                              ),
                                            );
                                          }
                                          return Promise.resolve();
                                        },
                                      }),
                                    ]}
                                  >
                                    <InputNumber
                                      min={1}
                                      addonAfter="GB"
                                      style={{ width: "100%" }}
                                      type="number"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={12}>
                                  <Form.Item
                                    {...field}
                                    name={[field.name, "imgdockertimeout"]}
                                    label="Timeout"
                                  >
                                    <InputNumber
                                      style={{ width: "100%" }}
                                      type="number"
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </div>
                          );
                        }}
                      </Form.Item>
                    </Card>
                  ))}
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                  >
                    Add Task Machine
                  </Button>
                </>
              )}
            </Form.List>
          </Card>
        </Row>
      )}

      {/* Resouce for eval */}
      <Row gutter={24} style={{ marginTop: 20 }}>
        <Card
          title={
            <Row justify={"space-between"}>
              <Col style={{ fontSize: "16px" }}>
                {t("Resource for Evaluation")}
              </Col>
            </Row>
          }
          style={{
            width: "100%",
            backgroundColor: "#F3F3F1",
            borderColor: "#cccccc",
          }}
        >
          <Form.List name="evaluations" initialValue={[{}]}>
            {(fields, { add, remove }) => (
              <>
                {fields.map((field, index) => (
                  <Card
                    key={field.key}
                    size="small"
                    title={`Eval Machine #${index + 1}`}
                    style={{
                      marginBottom: 16,
                      backgroundColor: "#F3F3F1",
                      borderTop: "1px solid #cccccc",
                      borderRight: "1px solid #cccccc",
                      borderBottom: "1px solid #cccccc",
                      borderLeft: "4px solid #faad14 ",
                    }}
                    extra={
                      <DeleteButtonWithConfirmSub
                        onDelete={() => remove(field.name)}
                      />
                    }
                    // extra={
                    //   // fields.length > 1 && (
                    //   <MinusCircleOutlined
                    //     onClick={() => remove(field.name)}
                    //     style={{ color: "#ff4d4f", fontSize: "16px" }}
                    //   />
                    //   // )
                    // }
                  >
                    <Form.Item shouldUpdate noStyle>
                      {({ getFieldValue }) => {
                        const selectedIds = (getFieldValue("evaluations") || [])
                          .map((m: any) => m?.preset)
                          .filter(Boolean);
                        return (
                          <Form.Item
                            {...field}
                            name={[field.name, "preset"]}
                            label={t("Eval Preset")}
                            rules={[
                              {
                                required: true,
                                message: "Please select a preset",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select Preset"
                              onChange={(val) =>
                                handleResourceChange(
                                  val,
                                  field.name,
                                  "evaluations",
                                )
                              }
                              options={resources.map((r) => ({
                                label: r.preset,
                                value: r.id,
                                disabled:
                                  selectedIds.includes(r.id) &&
                                  getFieldValue([
                                    "evaluations",
                                    field.name,
                                    "preset",
                                  ]) !== r.id,
                              }))}
                            />
                          </Form.Item>
                        );
                      }}
                    </Form.Item>

                    <Form.Item
                      shouldUpdate={(prev, curr) =>
                        prev.evaluations !== curr.evaluations
                      }
                      noStyle
                    >
                      {({ getFieldValue }) => {
                        const hasPreset = getFieldValue([
                          "evaluations",
                          field.name,
                          "preset",
                        ]);
                        if (!hasPreset) return null;

                        return (
                          <div style={{ marginTop: 16 }}>
                            <Row gutter={16}>
                              <Col span={12}>
                                <Form.Item
                                  {...field}
                                  name={[field.name, "hostnameevaluation"]}
                                  label="Hostname"
                                >
                                  <Input disabled />
                                </Form.Item>
                              </Col>
                              <Col span={12}>
                                <Form.Item
                                  {...field}
                                  name={[field.name, "ip_eval"]}
                                  label="IP"
                                >
                                  <Input disabled />
                                </Form.Item>
                              </Col>
                            </Row>

                            <Form.List name={[field.name, "cpueva"]}>
                              {(subFields) =>
                                subFields.map((subField, i) => (
                                  <Row key={subField.key} gutter={8}>
                                    <Col span={16}>
                                      <Form.Item
                                        {...subField}
                                        name={[subField.name, "cpueva"]}
                                        label={`CPU ${i + 1}`}
                                      >
                                        <Input disabled />
                                      </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                      <Form.Item
                                        {...subField}
                                        name={[subField.name, "coreeva"]} // หรือ "coreeva"
                                        label="Core"
                                        rules={[
                                          {
                                            required: true,
                                            message: "กรุณาระบุ core",
                                          },
                                          ({ getFieldValue }) => ({
                                            validator(_, value) {
                                              // 1. ดึง ID ของ Preset ในแถวปัจจุบันออกมา
                                              const presetId = getFieldValue([
                                                "evaluations",
                                                field.name,
                                                "preset",
                                              ]);
                                              const selectedResource =
                                                resources.find(
                                                  (r) => r.id === presetId,
                                                );

                                              if (selectedResource) {
                                                // 2. หาค่า Core สูงสุดจาก Preset (อ้างอิงตาม index ของ CPU)
                                                const maxCore =
                                                  selectedResource.detail.cpu[
                                                    subField.name
                                                  ]?.core;
                                                if (value > maxCore) {
                                                  return Promise.reject(
                                                    new Error(
                                                      `จำนวน Core ไม่ควรเกิน ${maxCore} (จำนวนที่รองรับ)`,
                                                    ),
                                                  );
                                                }
                                              }
                                              return Promise.resolve();
                                            },
                                          }),
                                        ]}
                                      >
                                        <InputNumber
                                          min={1}
                                          style={{ width: "100%" }}
                                          type="number"
                                        />
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                ))
                              }
                            </Form.List>
                            <Form.List name={[field.name, "gpueva"]}>
                              {(subFields) =>
                                subFields.map((subField, i) => (
                                  <Row key={subField.key} gutter={8}>
                                    <Col span={16}>
                                      <Form.Item
                                        {...subField}
                                        name={[subField.name, "gpueva"]}
                                        label={`GPU ${i + 1}`}
                                      >
                                        <Input disabled />
                                      </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                      <Form.Item
                                        {...subField}
                                        name={[subField.name, "cardeva"]}
                                        label="Card ID"
                                      >
                                        <InputNumber
                                          type="number"
                                          disabled={true}
                                          style={{ width: "100%" }}
                                        />
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                ))
                              }
                            </Form.List>
                            <Row gutter={16}>
                              <Col span={12}>
                                <Form.Item
                                  {...field}
                                  name={[field.name, "rameva"]} // หรือ "rameva"
                                  label="RAM (GB)"
                                  rules={[
                                    ({ getFieldValue }) => ({
                                      validator(_, value) {
                                        const presetId = getFieldValue([
                                          "evaluations",
                                          field.name,
                                          "preset",
                                        ]); // หรือ 'evaluations'
                                        const selectedResource = resources.find(
                                          (r) => r.id === presetId,
                                        );

                                        if (
                                          selectedResource &&
                                          value > selectedResource.detail.ram
                                        ) {
                                          return Promise.reject(
                                            new Error(
                                              `จำนวน Ram ไม่ควรเกิน ${selectedResource.detail.ram} (จำนวนที่รองรับ)`,
                                            ),
                                          );
                                        }
                                        return Promise.resolve();
                                      },
                                    }),
                                  ]}
                                >
                                  <InputNumber
                                    type="number"
                                    min={1}
                                    addonAfter="GB"
                                    style={{ width: "100%" }}
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={12}>
                                <Form.Item
                                  {...field}
                                  name={[field.name, "imgdockertimeouteva"]}
                                  label="Timeout"
                                >
                                  <InputNumber
                                    style={{ width: "100%" }}
                                    type="number"
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                          </div>
                        );
                      }}
                    </Form.Item>
                  </Card>
                ))}
                <Button
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<PlusOutlined />}
                >
                  Add Eval Machine
                </Button>
              </>
            )}
          </Form.List>
        </Card>
      </Row>
      {/* Image docker */}
      <Row gutter={24} style={{ marginTop: 20 }}>
        <Card
          title="Image Docker"
          style={{
            width: "100%",
            backgroundColor: "#F3F3F1",
            borderColor: "#cccccc",
          }}
        >
          <Row gutter={16}>
            <Col xs={24} md={6}>
              <Form.Item
                label={t("Docker Image Deletion Time (Days)")}
                name="imgdocker"
                rules={[
                  {
                    required: false,
                    message: "กรุณากรอกเวลาลบ Image Docker",
                  },
                ]}
              >
                <DatePicker
                  placeholder="date"
                  style={{ width: "100%" }}
                  inputReadOnly
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={4} style={{ display: "none" }}>
              <Form.Item
                name="timeimagedocker"
                label=" "
                rules={[
                  {
                    required: false,
                    message: "Please input time image docker!",
                  },
                  {
                    pattern: timePattern,
                    message: "กรุณากรอกเวลาในรูปแบบ HH:mm:ss เช่น 12:00:00",
                  },
                ]}
              >
                <Input
                  placeholder="HH:mm:ss"
                  maxLength={8}
                  onChange={(e) =>
                    handleTimeChange(e, (value) =>
                      props.form.setFieldsValue({
                        timeimagedocker: value,
                      }),
                    )
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>
      </Row>
    </div>
  );
};

export default ResourcePage;
